import getMeta from '../../storage/getMeta';
import getFieldValue from '../elements/getFieldValue';
import match from './match';

/**
 * Runs conditional checks, returning true if all given conditions are matched.
 *
 * @param {Element} form - The form to get field values from
 * @param {Array} conditions - The array of key-value conditions to match against the form
 * @returns {boolean} True if all conditions were matched
 */
export default function matchConditions(form, conditions) {
  return conditions.every((condition) => (
    Object.entries(condition).every(([name, value]) => (
      match(getFieldValue(form, name) || getMeta(name), value)
    ))
  ));
}
